import MetricsListWidget from "@pages/Home/MetricsListWidget.component";
import PageStructure, { PageContent, PageContentHeader, PageContentInner, Pane, PaneContent } from "@pages/PageStructure.component";
import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import { getPromptAnswer } from "@services/alert/alert.service";
import { getErrorMessage } from "@services/errors.service";
import toast from "@services/toast.service";
import { ReportBuilderMeasureORM } from "@models/reportBuilder";
import { MetricGrid } from "@components/pipelineNodes/PipelineNodeList.component";

const MetricsListPage = () => {
    const [search, setSearch] = useState('');
    const navigate = useNavigate();
        const createNewMetric = useCallback(async () => {
            const newName = await getPromptAnswer('What do you want to name this metric?', 'New Metric');
            if (!newName) {
                return;
            }
    
            try {
                const newMetric = await ReportBuilderMeasureORM.save({
                    id: null,
                    name: newName,
                    column_name: newName,
                    description: '',
                });
                navigate('/metric/' + newMetric.id);
            } catch (err) {
                toast('danger', 'Error', getErrorMessage(err));
            }
            
        }, []);
    return <PageStructure>
        <PageContent>
            <PageContentHeader>
                <div className="d-flex center-vertically">
                    <h1 className="mb-0">Metrics</h1>
                    <div className="flex-1 ps-5 pe-5">
                        <input type="text" className="form-control input-rounded input-search" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)}/>

                    </div>
                    <div>
                        <Link to="/semantic-layer" className="btn btn-outline-primary me-1">
                            <i className="mdi mdi-share-circle"></i> Visual Editor
                        </Link>
                        <DraftOnly>
                            <button className="btn btn-outline-primary" onClick={createNewMetric}>
                                <i className="mdi mdi-plus-thick"></i> New Metric
                            </button>
                        </DraftOnly>
                    </div>
                </div>
            </PageContentHeader>
            <PageContentInner hasHeader>
                <Pane>
                    <PaneContent>
                        <div className="p-4">
                            <MetricGrid searchQuery={search}/>

                        </div>
                    </PaneContent>
                </Pane>
            </PageContentInner>
            
        </PageContent>
    </PageStructure>
}

export default MetricsListPage;